import store from '@/store';

export default (to) => {
    if (!store.getters['auth/GUEST']) {
        return {name: 'home'}
    }
};
